module.exports = __webpack_public_path__ + "img/public/SiteIcons/verifyCheck.svg?7ce9c744";